'use strict';

import { Effect } from './Effect';
import { LUTPass } from 'three/examples/jsm/postprocessing/LUTPass';
import { Loader } from '../../threejs/loader/Loader';
import { LinearSRGBColorSpace } from 'three';

export class SceneLUT extends Effect{
	constructor () {
		super();
		
		this.effect = new LUTPass();
		this.active = false;
	}
	
	set config(conf) {
		this.active = conf.active;
		this.effect.intensity = conf.intensity;
		
		if (conf.lut) {
			const loader = new Loader().luteLoader;
			const lut = loader.parse(conf.lut);
			const texture = lut.texture3D;
			texture.colorSpace = LinearSRGBColorSpace;
			texture.needsUpdate = true;
			this.effect.lut = texture;
		}
	}
	
}
